import styled from 'styled-components';
import tw from 'twin.macro';

export const Heading = styled.h1<HeadingProps>`
  ${tw`pb-2 w-full headline-xl text-gray-700`}
  ${({ center }) => center && tw`text-center`}
`;

type HeadingProps = {
  center?: boolean;
};
